import { Box, Typography } from '@mui/material'
import { gradientBrand } from '../theme/brand'

const LOGO_SRC = '/moot-court-navbar-logo.jpg'
const LOGO_ALT = 'Phiên Toà Giả Định - Công Lý Giới'

interface LogoProps {
  variant?: 'sidebar' | 'header' | 'compact'
  showText?: boolean
}

export default function Logo({ variant = 'sidebar', showText = true }: LogoProps) {
  if (variant === 'compact') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          component="img"
          src={LOGO_SRC}
          alt={LOGO_ALT}
          sx={{
            width: 40,
            height: 40,
            objectFit: 'contain',
            filter: 'drop-shadow(0 2px 6px rgba(20, 78, 140, 0.18))',
          }}
        />
        {showText && (
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              background: gradientBrand,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Moot Court
          </Typography>
        )}
      </Box>
    )
  }

  if (variant === 'header') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          component="img"
          src={LOGO_SRC}
          alt={LOGO_ALT}
          sx={{
            width: 36,
            height: 36,
            objectFit: 'contain',
            filter: 'drop-shadow(0 2px 6px rgba(20, 78, 140, 0.18))',
          }}
        />
        {showText && (
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                lineHeight: 1.2,
                fontSize: '1rem',
                background: gradientBrand,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Gender Justice
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: 'text.secondary',
                fontSize: '0.7rem',
                fontWeight: 600,
                letterSpacing: 1.2,
                textTransform: 'uppercase',
              }}
            >
              Moot Court · 2026
            </Typography>
          </Box>
        )}
      </Box>
    )
  }

  // Sidebar variant (default) - Compact version
  return (
    <Box
      sx={{
        height: 64,
        px: 2,
        background: gradientBrand,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        boxShadow: '0 2px 12px rgba(20, 78, 140, 0.28)',
      }}
    >
      <Box
        component="img"
        src={LOGO_SRC}
        alt={LOGO_ALT}
        sx={{
          width: 54,
          height: 54,
          objectFit: 'contain',
          display: 'block',
          flexShrink: 0,
          filter: 'drop-shadow(0 3px 8px rgba(0,0,0,0.2))',
        }}
      />
      {showText && (
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              color: 'white',
              lineHeight: 1.15,
              fontSize: '0.92rem',
              textShadow: '0 1px 2px rgba(0,0,0,0.2)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            Gender Justice
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: 'rgba(255, 255, 255, 0.9)',
              fontWeight: 600,
              letterSpacing: 1.2,
              fontSize: '0.65rem',
              textTransform: 'uppercase',
              display: 'block',
              lineHeight: 1.3,
            }}
          >
            Moot Court · 2026
          </Typography>
        </Box>
      )}
    </Box>
  )
}
